import React from "react";
import { Link } from "react-router-dom";
import CharchaShortSlider from "../../AllEpisode/AllEpisode_Components/CharchaShortSlider";

const ShortReelBanner = ({
  episodeData,
  episodeListData,
  episodeId,
  setEpisodeId,
  handleclick,
  handleShareData,
  sharetext,
  sequence,
  setEpisodesequence
}) => {
  const episodeTitle = episodeData?.title || "";
  const shortsData = episodeData?.parikshadata?.shorts;
  console.log(episodeId);

  const getNextEpisode = (sequence) => {
    if (sequence <= 7) {
      const next = parseInt(sequence) + 1;
      if (next < 8) {
        let final = episodeListData.filter((val) => val.sequence == next);

        return final;
      } else if (sequence == 7) {
        let final = episodeListData.filter((val) => val.sequence == 7);
        return final;
      } else {
        return null;
      }
    }
  };

  return (
    <section className="episode_banner_section episode_banner_section_reel">
      <div className="container-fluid">
        <div className="episode_banner_pad">
          <ul className="episode_breadcrumb episode_breadcrumb_active">
            {episodeListData?.map((episode, index) => (
              <li key={index + 1}>
                <Link
                  to="#"
                  className={sequence == episode.sequence ? "active" : ""}
                  onClick={() => setEpisodeId(episode.id)}
                >
                  {`Episode ${index + 1}`}
                </Link>
              </li>
            ))}
          </ul>
          <div className="videoppc_mainflex">
            <div className="body_edition">
              <h3>{episodeTitle}</h3>
            </div>

            <div className="nextepi_order">
              <button
                className="nextepic_btn"
                onClick={() => {
                  let id = getNextEpisode(episodeData.sequence)[0].id;
                  let sequence = getNextEpisode(episodeData.sequence)[0].sequence;
                  if (id) {
                    setEpisodeId(id);
                    setEpisodesequence(sequence)
                  }
                }}
                // onClick={() => setEpisodeId((prev) => parseInt(prev) + 1)}
                disabled={episodeData.sequence > 6}
              >
                <img src="/assets/images/nextepisodeplay.svg" alt="" /> Next
                Episode
              </button>
              {episodeData.sequence < 7 && (
                <h6>{getNextEpisode(episodeData.sequence)[0].title}</h6>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="episode_banner_pad">
          <div className="charcha_slider charcha_slider_reel vremove_num">
            {shortsData && (
              <CharchaShortSlider
                shortsData={shortsData}
                handleclick={handleclick}
                isShortReel={true}
                type="shorts"
                sharetext={sharetext}
                handleShareData={handleShareData}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShortReelBanner;
